import { styled } from 'troyfe';

const Wrap = styled.div`
  .title {
    font-size: 2rem;
    font-weight: 540;
    padding: 2.4rem 0 2.4rem 3.2rem;
    border-bottom: 1.6px solid #F1F2F4;
  }
  .table{
      margin-top:20px;
  }
  .del{
      color:#FF513D;
  }
  .data{
      width:100%;
      display:flex;
      margin-top:3.875rem;
      .dataCard{
        width: 30rem;
        height: 13.5rem;
        background: #FFFFFF;
        border-radius: 0.5rem;
        border: 0.0625rem solid #E2E2E2;
        margin:0rem 4.875rem;
        div{
            width:100%;
            text-align:center;
        }
        .name{
            font-size: 1.7rem;
            margin-top:4.5rem;
        }
        .quantity{
            margin-top:1.625rem;
            font-size: 2.5rem;
        }
        .one{
            color:#FF513D;
        }
        .two{
            color:#FD9E0D;
        }
        .three{
            color:#44BB55;
        }
        .four{
            color:#158EFF;
        }
      }
  }
`;


export { Wrap };
